var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"main-box"},[_c('xr-table',{ref:"xrTable",attrs:{"configure":_vm.configure}}),_vm._v(" "),(_vm.isPageAddShow)?_c('page-add',{ref:"pageAdd",on:{"callBackMethod":_vm.refreshTable}}):_vm._e(),_vm._v(" "),(_vm.isPageEditShow)?_c('page-edit',{ref:"pageEdit",on:{"callBackMethod":_vm.refreshTable}}):_vm._e()],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-7f5e9f95","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/template/NormalTable.vue
// module id = null
// module chunks = 